import { configureStore } from '@reduxjs/toolkit';

//slices
import cartReducer from '../feature/cartSlice';

export default configureStore({
    reducer: {
        cart: cartReducer
    }
})